import { render } from "./App.vue?vue&type=template&id=3b277c6f&async=true"
import script from "./App.vue?vue&type=script&async=true&lang=js"
export * from "./App.vue?vue&type=script&async=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=3b277c6f&async=true&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__